// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';
import { v1UserCapacitySchema } from './v1/userCapacitySchema';

export const listUsersCapacitiesPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const listUsersCapacitiesQueryParamsSchema = z.object({
  user_ids: z.optional(z.coerce.string().describe("Comma-separated list of user IDs to filter by")),
  since: z.optional(z.string().date().describe("Fetch capacities after this date (YYYY-MM-DD)")),
  until: z.optional(z.string().date().describe("Fetch capacities before this date (YYYY-MM-DD)")),
}).optional();

export const listUsersCapacitiesHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Users capacities retrieved successfully
 */
export const listUsersCapacities200Schema = z.array(z.object({
  user_id: z.optional(z.number().int().describe("User ID")),
  capacities: z.optional(z.array(z.lazy(() => v1UserCapacitySchema))),
}));

/**
 * @description Unauthorized
 */
export const listUsersCapacities401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

export const listUsersCapacitiesQueryResponseSchema = z.lazy(() => listUsersCapacities200Schema);
